<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'instructive-view'">
  <div class="view-container pb-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHomeItem"
      class="max-w-full breadcrumb-style" />

    <div [style]="{'min-height':'200px'}">
      <div class="container">
        <div class="header-container mt-2">
          <div class="title-container">
              <span class="text-xl font-bold">
                {{'UserPages.InstructiveView.PageTitle' | translate}}
              </span>
            <div *ngIf="instructiveInfo">
              <span class="update-text">
                {{'UserPages.InstructiveView.LastUpdateText' | translate}}: 
                {{instructiveInfo.lastInstructiveUpdate ? 
                  (instructiveInfo.lastInstructiveUpdate | date: 'dd/MM/YYYY hh:mm') :
                  ""
                }}
              </span>
            </div>
          </div>
          <div class="btns-right">
            <p-button
              [loading]="loadingBtnInstructive"
              pTooltip=""
              styleClass="p-button-outlined p-button-sm"
              class="update-btn action-btn"
              tooltipPosition="bottom" (onClick)="loadInstructiveInfo()" [style]="{'margin-right':'1em'}">
              <span class="material-symbols-outlined mr-2">
                sync
              </span>
              {{'UserPages.InstructiveView.UpdateBtn' | translate}}
            </p-button>

            <p-button
              [loading]="loadingBtnInstructive"
              pTooltip=""
              styleClass="p-button-text p-button-sm"
              class="action-btn"
              tooltipPosition="bottom" (onClick)="getInstructivePdf(importOrderDetailGuid)">
              <span class="material-symbols-outlined mr-2">
                system_update_alt
              </span>
              {{'UserPages.InstructiveView.ExportPDF' | translate}}
            </p-button>
          </div>
        </div>
      </div>
      <section class="cards-container" *ngIf="instructiveInfo">
        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.InstructiveHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.NumberLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.CreationDateLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ContactLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PhoneLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.EmailLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="instructiveInfo.number || '(No data)'"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="instructiveInfo.created || '(No data)'"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="instructiveInfo.contact || '(No data)'"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="instructiveInfo.contactPhone || '(No data)'"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="instructiveInfo.contactEmail ||  '(No data)'"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.PlantHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.plantLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.AddressLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>

                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ContactLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>

                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PhoneLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>

                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.EmailLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>

                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.fridgeStorageName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.fridgeStorageContactAddress || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.fridgeStorageContactName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.fridgeStorageContactPhone|| '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.fridgeStorageContactEmail || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.CustomsAgentHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.CompanyLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ContactLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PhoneLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.AddressLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.EmailLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.customAgentCompanyName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.customAgentContactName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.customAgentPhone || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.customAgentContactAddress || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.customAgentEmail || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.SaleTypeHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.FreightTypeLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PaymentMethodLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.SaleMethodLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.IncontermLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.paymentAgainstLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.typefreight || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.paymentMethod || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.salesModality || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.typeSale || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.paymentAgainst + '%' || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.ExporterHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ExporterLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.AddressLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.RutLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ContactLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PhoneLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.EmailLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.exporterCompanyName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.exporterContactAddress || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.exporterVAT || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.exporterContactName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.exporterContactPhone || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.exporterContactEmail || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.ImporterHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ImporterLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.AddressLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.RutNitLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ContactLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PhoneLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.EmailLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.importerCompanyName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.importerContactAddress || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.importerVAT || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.importerContactName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.importerContactPhone || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.importerContactEmail || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.ConsigneeHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.CompanyLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.AddressLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ContactLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PhoneLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.EmailLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.consigneeCompanyName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.consigneeContactAddress || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.consigneeContactName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.consigneeContactPhone || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.consigneeContactEmail || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-separator">
          <div class="table-info">
            <div class="table-info-header bg-grey">
              <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.NotityHeader' | translate}}</span>
            </div>
            <div class="table-info-body">
              <div class="cell-title">
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.CompanyLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.AddressLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.ContactLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.PhoneLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [classStyle]="customClass"
                    [text]="'UserPages.InstructiveView.LabelsHeaders.EmailLabel' | translate"
                    [maxLength]="40">
                  </app-text-preview>
                </div>
              </div>
              <div class="cell-full-width">
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.notifierCompanyName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.notifierContactAddress || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.notifierContactName || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.notifierContactPhone || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
                <div class="cell-table">
                  <app-text-preview
                    [text]="instructiveInfo.notifierContactEmail || '(No data)'"
                    [maxLength]="40"
                    [classStyle]="customClass">
                  </app-text-preview>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="xl:space-flex"></div>


      </section>

      <section class="section-tables" *ngIf="instructiveInfo">
        <div class="table-info-fit">
          <div class="table-info-header bg-grey">
            <span class="header-text">{{'UserPages.InstructiveView.TitlesHeaders.ShipmentHeader' | translate}}</span>
          </div>
          <div class="table-info-body">
            <div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.ShipperLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.NaveLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.ContainerLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.SealLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.BookingLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.ShippingLineLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.DeparturePortLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.DepartureDateLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.ArrivalPortLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.ArrivalDateLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.SpsDateLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.DusDateLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.BlDateLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.LoadDatetimeLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.StackingLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.CutoffDateLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="'UserPages.InstructiveView.ShipmentTable.PackagesTypeLabel' | translate"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
            </div>
            <div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.carrierName || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.ship || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.containerNumber || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.seal || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.booking || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.shippingCompanyName || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.departurePortName || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="(instructiveInfo.etd ? (instructiveInfo.etd | date: 'dd-MM-yyyy') : '(No data)') ?? '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.destinationPortName || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="(instructiveInfo.eta ? (instructiveInfo.eta | date: 'dd-MM-yyyy') : '(No data)') ?? '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.sps || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.dus || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.bl || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.planLoadDate || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.stacking || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.cutoffDate || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
              <div class="cell-table">
                <app-text-preview
                  [text]="instructiveInfo.typePallets || '(No data)'"
                  [maxLength]="40"
                  [classStyle]="customClass">
                </app-text-preview>
              </div>
            </div>
          </div>
        </div>
        
        <div class="table-info-flex">
          <div *ngIf="instructiveInfo?.palletsInstructive">
            <p-table 
              [value]="instructiveInfo.palletsInstructive!"
              styleClass="p-datatable-gridlines"
              class="loading-table">
              <ng-template pTemplate="caption">
                <span class="header-text">
                  {{'UserPages.InstructiveView.TitlesHeaders.LoadingHeader' | translate}}
                </span>
              </ng-template>
              <ng-template pTemplate="header">
                  <tr class="font-semibold">
                    <th>{{'UserPages.InstructiveView.LoadingTable.SpecieHeader' | translate}}</th>
                    <th>{{'UserPages.InstructiveView.LoadingTable.VarietyHeader' | translate}}</th>
                    <th>{{'UserPages.InstructiveView.LoadingTable.LabelHeader' | translate}}</th>
                    <th>{{'UserPages.InstructiveView.LoadingTable.PackagingHeader' | translate}}</th>
                    <th>{{'UserPages.InstructiveView.LoadingTable.CategoryHeader' | translate}}</th>
                    <th>{{'UserPages.InstructiveView.LoadingTable.CaliberHeader' | translate}}</th>
                    <th>{{'UserPages.InstructiveView.LoadingTable.PalletsHeader' | translate}}</th>
                    <th>{{'UserPages.InstructiveView.LoadingTable.BoxesHeader' | translate}}</th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                  <tr>
                    <td>{{row.speciesName || "(No data)"}}</td>
                    <td>{{row.varietyName || "(No data)"}}</td>
                    <td>{{row.label || "(No data)"}}</td>
                    <td>{{row.packaging || "(No data)"}}</td>
                    <td>{{row.category || "(No data)"}}</td>
                    <td>{{row.speciesSize || "(No data)"}}</td>
                    <td>{{row.pallets || "(No data)"}}</td>
                    <td>{{row.boxesPerPallets || "(No data)"}}</td>
                  </tr>
                  <tr *ngIf="rowIndex === 0 || instructiveInfo.palletsInstructive?.[rowIndex-1]?.palletCodes !== row.palletCodes">
                    <td colspan="8" class="group-header">
                      <span class="font-semibold label-table">Pallets: </span>
                      {{addSpaceString(row.palletCodes) || "(No data)"}}
                    </td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                  <td colspan="6" class="text-right">
                    <span class="font-semibold">{{'UserPages.InstructiveView.LoadingTable.TotalLabel' | translate}}</span>
                  </td>
                  <td class="font-semibold">{{ instructiveInfo.totalPallets }}</td>
                  <td class="font-semibold">{{ instructiveInfo.totalBoxes }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div class="table-columns">
                  <div class="cell-full-column footer-padding">
                    <span class="font-semibold label-table text-left">
                      {{'UserPages.InstructiveView.LoadingTable.SetupLabel' | translate}}:
                    </span>
                    <div class="cell-full">
                      <span class="label-table font-normal">
                        {{'UserPages.InstructiveView.LoadingTable.TemperatureLabel' | translate}}:
                      </span>
                      <span class="font-normal">{{instructiveInfo.temperature}}</span>
                    </div>
                    <div class="cell-full">
                      <span class="label-table font-normal">
                        {{'UserPages.InstructiveView.LoadingTable.VentilationLabel' | translate}}:
                      </span>
                      <span class="font-normal">{{instructiveInfo.cbm}}</span>
                    </div>
                  </div>

                  <div class="observations-section mt-2 flex flex-column pb-8">
                    <span class="font-semibold footer-padding pt-2">
                      {{'UserPages.InstructiveView.LoadingTable.ObservationsLabel' | translate}}: 
                    </span>
                    <span class="font-normal footer-padding">
                      {{instructiveInfo.observations || ""}}
                    </span>
                  </div>
                </div>
              </ng-template>
            </p-table>
          </div>
        </div>

      </section>
    </div>
  </div>
</app-user-dashboard>

